__turbopack_context__.v({
  "mainImage": "MainMedia-module__Nx1QQq__mainImage",
});
